/*jshint esversion: 6 */
/* global interact */
import { Controller } from "stimulus";
import Sortable from 'sortablejs';
import { htmlToElement } from '.././helpers/dom';

export default class extends Controller {
  static targets = [ "schoolCreditScoreTemplate", "schoolCreditScoresFormContainer", "schoolCreditScoreName", "schoolCreditScoreForm" ]

  connect() {
    // if (this.hasSchoolFieldFormTarget) {
    //   // Show the first skill category while all others are hiding
    //   this.schoolCreditScoreFormTargets[0].classList.toggle('hidden');
    // }

    // Make the skill category selectors sortable
    const sortable = document.querySelector('#school-credit-scores-sortable.sortable');
    var el = Sortable.create(sortable, {
      animation: 150,
      draggable: "li.btn",
      filter: ".ignore-sort",
      forceFallback: true,
      onEnd: function(event) {
        let schoolCreditScoreId = event.item.getAttribute('data-school-credit-score-id');
        document.querySelector(`[data-school-credit-score-id="${schoolCreditScoreId}"] input.position`).value = event.newIndex + 1;
      }
    });

    // Highlight initial skill category
    // document.querySelector('#school-credit-scores-sortable.sortable li').classList.add('btn-pink');
  }

  switchTo(event) {
    this.schoolCreditScoreFormTargets.forEach((el, i) => {
      el.classList.toggle("hidden", el.dataset.schoolCreditScoreId != event.target.dataset.schoolCreditScoreId)
    });

    // Highlight selected tab
    let sortableSelector = '#school-credit-scores-sortable.sortable li.btn-pink'
    if (document.querySelector(sortableSelector) != null) {
      document.querySelector(sortableSelector).classList.remove('btn-pink');
    }
    event.target.classList.add('btn-pink');
  }

  addNewItem(event) {
    const id = new Date().getTime();
    const template = `<li class='inline-block mr-10 mb-14 btn' data-target='schools--school-credit-scores.schoolCreditScoreName' data-action='click->schools--school-credit-scores#switchTo' data-school-credit-score-id='${id}'>New Field</li>`
    const newElementLink = htmlToElement(template);
    const parentElement = document.getElementById("school-credit-scores-sortable");
    parentElement.insertAdjacentElement("beforeend", newElementLink);
    newElementLink.addEventListener("click", (ev) => {
      this.switchTo(ev);
    });
    const newElementForm = htmlToElement(this.schoolCreditScoreTemplateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, id));
    newElementForm.dataset.schoolCreditScoreId = id;
    this.schoolCreditScoresFormContainerTarget.insertAdjacentElement('beforeend', newElementForm);

    window.expandableTextArea();
    newElementLink.click();
  }

  updateTitle(event) {
    const schoolCreditScoreId = event.target.parentElement.parentElement.parentElement.dataset.schoolCreditScoreId;
    this.schoolCreditScoreNameTargets.find(el => el.dataset.schoolCreditScoreId  == schoolCreditScoreId).innerText = event.target.value;
  }

  removeItem(event) {
    if (confirm('Are you sure?') == true) {
      const itemForm = event.target.parentElement;
      const schoolCreditScoreId = itemForm.dataset.schoolCreditScoreId;
      this.schoolCreditScoreNameTargets.find(el => el.dataset.schoolCreditScoreId  == schoolCreditScoreId).style.display = 'none';
      itemForm.querySelector("input[name*='_destroy']").value = 1;
      itemForm.style.display = 'none';
    }
  }

  _insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  _insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }
}
